import { FormHelperText, InputLabel, MenuItem } from '@material-ui/core';
import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';

import Deed from 'entities/deed/model';
import { DateRangeWithTimeZone } from 'components/DeedListDateInfoWithStatus/DateRangeWithTimeZone';

export const RoleSelector = ({
  deed,
  onChange,
  values,
  allowMultiple,
}: {
  deed: Deed;
  onChange: (roles: Array<string>) => void;
  values: Array<string>;
  allowMultiple?: boolean;
}) => {
  const handleCheckboxChange = (checked: boolean, roleId: string) => {
    const newValues = allowMultiple ? values : [];
    if (checked) {
      onChange([...newValues, roleId]);
    } else {
      onChange(newValues.filter((v) => v !== roleId));
    }
  };

  const IconComponent = allowMultiple ? Checkbox : Radio;

  return deed?.roles?.size > 0 ? (
    <div style={{ marginTop: 15, marginBottom: 5 }}>
      <InputLabel>Role</InputLabel>
      {deed.roles.map(
        (role) =>
          role && (
            <div style={{ display: 'flex', alignItems: 'center' }} key={role.get('id')}>
              <div>
                <IconComponent
                  onChange={() => handleCheckboxChange(!values.includes(role.id), role.id)}
                  checked={values.includes(role.id)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <MenuItem
                  onClick={() => handleCheckboxChange(!values.includes(role.id), role.id)}
                  key={role.get('id')}
                  value={role.get('id')}
                >
                  <div>
                    <div>{role.get('name')}</div>
                    {role.get('startingAt') && (
                      <div>
                        <DateRangeWithTimeZone
                          startingAt={role.get('startingAt')}
                          endingAt={role.get('endingAt')}
                          withTime
                          fontSize={11}
                          timeZone={deed.timeZone}
                        />
                      </div>
                    )}
                  </div>
                </MenuItem>
              </div>
            </div>
          )
      )}
      {deed?.type === 'Project' && (
        <FormHelperText style={{ marginTop: 10 }}>
          By adding this employee to the role, they will be an approved application, and receive
          confirmation that they have joined the project.
        </FormHelperText>
      )}
    </div>
  ) : null;
};
